import { FunctionComponent, useState } from 'react'
import styles from './mealChild.module.scss'
import Title from '@/components/_custom/Title/title.tsx'
import { useTranslation } from 'react-i18next'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import MealChildSettings from './mealChildSettings.tsx'

interface MealChildProps {
    childId: number
    showRegular: boolean
}

const MealChild: FunctionComponent<MealChildProps> = ({ childId, showRegular }: MealChildProps) => {
    const { t } = useTranslation()

    const [showMore, setShowMore] = useState<boolean>(!showRegular)

    return (
        <div className={styles.Form}>
            <div className={`${styles.TitleAndButton} ${showMore ? '' : styles.NoMarginBottom}`}>
                <div className={styles.Title} onClick={() => setShowMore(!showMore)}>
                    <Title text={t('meal')}></Title>
                    {showMore ? (
                        <KeyboardArrowUp className={styles.Icon} />
                    ) : (
                        <KeyboardArrowDown className={styles.Icon} />
                    )}
                </div>
            </div>
            {showMore && <MealChildSettings childId={childId} />}
        </div>
    )
}

export default MealChild
